import axios from 'axios';
import * as endpoints from './const';

class GlobalSearchApi {
  static fetchSearchHistory(fetchParams) {
    return axios
      .get(`${endpoints.SEARCH_HISTORY}`, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static saveToSearchHistory(searchTerm, catergory) {
    return axios
      .post(endpoints.SEARCH_HISTORY, {
        SearchTerm: searchTerm,
        HistoryCategory: catergory
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static fetchDrivers(fetchParams) {
    return axios
      .get(`${endpoints.DRIVER_SEARCH}`, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static fetchVehicles(fetchParams) {
    return axios
      .get(`${endpoints.VEHICLE_SEARCH}`, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static fetchSearchResults(fetchParams) {
    return axios
      .all([
        GlobalSearchApi.fetchDrivers(fetchParams),
        GlobalSearchApi.fetchVehicles(fetchParams)
      ])
      .then(axios.spread((drivers, vehicles) => ({ drivers, vehicles })))
      .catch(error => {
        throw error;
      });
  }
}

export default GlobalSearchApi;



// WEBPACK FOOTER //
// ./src/api/GlobalSearchApi.js